var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguages(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31282 15.6872C1.67187 14.0462 0.75 11.8206 0.75 9.5C0.75 7.17936 1.67187 4.95376 3.31282 3.31282C4.95376 1.67187 7.17936 0.75 9.5 0.75C11.8206 0.75 14.0462 1.67187 15.6872 3.31282C17.3281 4.95376 18.25 7.17936 18.25 9.5C18.25 11.8206 17.3281 14.0462 15.6872 15.6872C14.0462 17.3281 11.8206 18.25 9.5 18.25C7.17936 18.25 4.95376 17.3281 3.31282 15.6872Z",
    stroke: "url(#paint0_linear_160_5359)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84835 3.31282C6.14509 4.95376 5.75 7.17936 5.75 9.5C5.75 11.8206 6.14509 14.0462 6.84835 15.6872C7.55161 17.3281 8.50544 18.25 9.5 18.25C10.4946 18.25 11.4484 17.3281 12.1516 15.6872C12.8549 14.0462 13.25 11.8206 13.25 9.5C13.25 7.17936 12.8549 4.95376 12.1516 3.31282C11.4484 1.67187 10.4946 0.75 9.5 0.75C8.50544 0.75 7.55161 1.67187 6.84835 3.31282Z",
    stroke: "url(#paint1_linear_160_5359)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 12.4163H17.625M1.375 6.58301H17.625",
    stroke: "url(#paint2_linear_160_5359)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_5359",
    x1: 0.75,
    y1: 9.5,
    x2: 18.25,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_160_5359",
    x1: 5.75,
    y1: 9.5,
    x2: 13.25,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_160_5359",
    x1: 1.375,
    y1: 9.49967,
    x2: 17.625,
    y2: 9.49967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguages);
export default __webpack_public_path__ + "static/media/languages.d8220cda6094fa4036ab7318407f7ad8.svg";
export { ForwardRef as ReactComponent };